//! English [en] is moment's built-in locale, so it is not vendored here: this
//! file only patches its `ss`, which is a flat "%d seconds". The app's
//! thresholds (`setTimeDifferenceThresholds`) send every 1–59 s difference to
//! `ss`, so one second read "1 seconds ago" (FE #461).
//!
//! Must be imported BEFORE `en-dmy.js`: a child locale copies its parent's
//! config when it is defined, and `updateLocale` does not reach children
//! defined earlier.

import moment from 'moment';

export default moment.updateLocale('en', {
  relativeTime: {
    ss: (number) => (number === 1 ? '1 second' : number + ' seconds'),
  },
});
